import { render } from "./Adminimport.vue?vue&type=template&id=379fe811&ts=true"
import script from "./Adminimport.vue?vue&type=script&lang=ts"
export * from "./Adminimport.vue?vue&type=script&lang=ts"

import "./Adminimport.vue?vue&type=style&index=0&id=379fe811&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__